import axios from 'axios'

export const logout = () => {
    // localStorage.removeItem('TOKEN_KEY');
    localStorage.clear()
}

export const isLogin = () => {
    if (localStorage.getItem('TOKEN_KEY')) {
        return true;
    }
    return false;
}

export const isCustomerLoggedIn = () => {
    if (localStorage.getItem('token')) {
        return true;
    }
    return false;
}
export const setAuthTokenForCustomer = (token) => {
    if (token) {
        // console.log(token,"this is token")
        axios.defaults.headers.common["Authorization"] = token;
        axios.defaults.headers.common["x-auth"] = token;
    } else {
        delete axios.defaults.headers.common["Authorization"];
        delete axios.defaults.headers.common["x-auth"];
    }
};

export const setAuthToken = (token) => {
    if (token) {
        axios.defaults.headers.common["Authorization"] = token;
        axios.defaults.headers.common["x-auth"] = token;
    } else {
        delete axios.defaults.headers.common["Authorization"];
        delete axios.defaults.headers.common["x-auth"];
    }
}

export const PAYMENT_APPROVER = "kanishka@decorpot.com"

export const ADMINHEADER = ["Sl No", "Scope", "Unit", "Qty/Area", "Total Price", "PO/MTR Requested", "SO Requested", "Overall Cost", "Margin %"]

export const ADMINHEADERMULTSELECTNEW = ["Sl No", "Scope", "Area(mm)", "Area(SqFt)", "Qty", "Total Price", "PO/MTR Requested", "SO Requested", "Overall Cost", "Margin %"]

export const NONADMINHEADERMULTSELECTNEW = ["Sl No", "Scope", "Area(mm)", "Area(SqFt)", "Qty", "PO/MTR Requested", "SO Requested"]

export const TABLEHEADER = ["Sl No", "Scope", "Unit", "Qty/Area", "PO/MTR Requested", "SO Requested"]

export const EM_TABLEHEADER = ["Sl No", "Scope","PO/MTR Requested", "SO Requested"]

export const SCOPEDPRODUCTSHEADER = ['Sl No', 'Materila Name', 'Qty/Area', 'Price Per Unit', "Total"]

export const INWARDTABLEHEADER = ['Sl No', 'Order Id', 'Status', 'Vendor', 'Value', 'Created At', 'Action']

export const POSORAISEDHEADER = ['Sl No', 'Order Id', 'Status', 'Vendor', 'Value', 'Created At', 'Action']

// Role _ids, for the few checks that need the id rather than the name.
export const ROLEID = {
    Admin: '5cab1c7197ba0c092180e007',
    NaraciTechManager: '6852a630ca63f94068f6a064',
    NaraciTechUser: '6852a644b7135f40ae7a0f01',
}

// Roles allowed to replace a document captured at the Design Sign-Off stage.
// The server holds the same list in utils/constants.js and enforces it; this
// only keeps the page out of everyone else's way.
export const DESIGN_SIGN_OFF_DOC_EDITOR_ROLE_IDS = [
    ROLEID.Admin,
    ROLEID.NaraciTechManager,
    ROLEID.NaraciTechUser,
]

// Roles allowed to regenerate a lead's payment QR code. The QR encodes the UPI
// virtual account the customer pays into, so this changes where money lands.
// The server holds the same list in utils/constants.js and enforces it.
export const PAYMENT_QR_EDITOR_ROLE_IDS = [
    ROLEID.Admin,
    ROLEID.NaraciTechManager,
    ROLEID.NaraciTechUser,
]

// Roles allowed to see the cron job monitor. It shows endpoint URLs and raw
// error text from the servers, so it stays with the people who act on them.
export const CRON_MONITOR_ROLE_IDS = [
    ROLEID.Admin,
    ROLEID.NaraciTechManager,
    ROLEID.NaraciTechUser,
]

// Roles allowed to send in-app notifications. inventoryapi holds the same
// list in routes/notification.js and enforces it; this only keeps the page out
// of everyone else's way.
export const NOTIFICATION_SENDER_ROLE_IDS = [
    ROLEID.Admin,
    ROLEID.NaraciTechManager,
    ROLEID.NaraciTechUser,
]

export const ROLENAME = {
    Admin: 'Admin',
    MarketingManager: 'Marketing Manager',
    MarketingUser: 'Marketing User',
    DGM_Marketing: 'DGM Marketing',
    SalesManager: 'Sales Manager',
    SalesUser: 'Sales User',
    SalesHead: 'Sales Head',
    AGMSales: 'AGM Sales',
    AGMDesign: 'AGM Design',
    DGM_Sales: 'DGM Sales',
    ProjectManager : 'Project Manager',
    SiteInspector : 'Site Inspector',
    OperationDesignManager: 'Operation Design Manager',
    DesignManager: 'Design Manager',
    AssistantDesignManager: 'Assistant Design Manager',
    DesignUser: 'Design User',
    DesignHead: 'Design Head',
    DGM_Design: 'DGM Design',
    FinanceManager: 'Finance Manager',
    FinanceExecutive:'Finance Executive',
    BOMManager: 'BOM Manager',
    CenterHead: 'Center Head',
    BusinessHead: 'Business Head',
    DocumentUploader: 'Document Uploader',
    FinalMarking: 'Final Marking',
    QualityControl: 'Quality Control',
    QCManager: 'QC Manager',
    SeniorOperationManager: 'Senior Operation Manager',
    ScopeAdmin: 'Scope Admin',
    SiteQC: 'Site QC',
    IMOSManager: 'IMOS Manager',
    BOMExecutive: 'BOM Executive',
    ProcurementExecutive: 'Procurement Executive',
    OperationHead: 'Operation Head',
    IMOSUser: 'IMOS User',
    FactoryManager: 'Factory Manager',
    AssistantSalesManager:'Assistant Sales Manager',
    LnDManager: 'LnD_Manager',
    LnDUser: 'LnD_User',
    HRUser: 'HR User',
    HRManager: 'HR Manager',
    HRAssistantManager: 'Assistant Manager HR',
    AssistanceDesignManager: 'Assistance Design Manager',
    MaterialManager: 'Material Manager',
    FactoryBom:"Factory Bom",
    SiteBom:"Site Bom",
    CHM_Manager: 'CHM_Manager',
    CHM_User :'CHM_User',
    Execution_Manager:'Execution Manager',
    ExecutionUser:'Execution User',
    Store_Manager:'Store Manager',
    FinanceUser:'Finance User',
    VendorSOManager: "Vendor SO Manager",
    VendorSOExecutive: "Vendor SO Executive",
    OperationManager:"Operation Manager",
    DGM_Ops:"DGM Ops",
    FactoryCrmUser: "Factory CRM",
    Customer: 'Customer',
    ProductionManager: 'Production Manager',
    DataAnalyst : 'Data Analyst',
    TeleCallerUser : 'TeleCaller',
    TeleCallerManager : 'TeleCallerManager',
    TeleCallerAssistantManager: 'TeleCallerAssistantManager',
    ExecutionSurveyFormViewer : 'Execution Survey Forms Viewer',
    ChannelPartner : 'Channel Partner',
    ExecutionHead: 'Execution Head',
    AGM_Sales : "AGM Sales",
    AGM_Design: 'AGM Design',
    NaraciTechManager: "Naraci Tech Manager",
    NaraciTechUser : "Naraci Tech User",
    QC_Head: "QC Head",
    marketingAnalyst: "Marketing Analyst",
    DecorpotRFDExecutives:"Rfd Executives",
    DecorpotRFDManager:"Rfd Manager",
    SnagView: 'Snag View',
    HardwareSnagDispatcher: 'Hardware Snag Dispatcher',
}

export const CURRENT_STAGE = ['Lead Received', 'Won', 'Lost', 'Assign to Designer', 'Designer Assigned', "Design Sign-off", 'Site QC', ]

export const LEADSTATUS = {
    RealLead: 'Real',
    JunkLead: 'Junk',
    HoldLead: 'Hold',
    TBCLead: 'To Be Called',
    LeadReceived: 'Lead Received',
    TotalLeadsGenerated: 'Total Leads Generated',
    LeadReturnedBySales: 'Lead Returned By Sales'
}

export const EXPCENTERID = {
    whiltefield: '61ea728cb2e70b55ec16a88c',
    hsr: '61e7fcd79905175441887eb9',
    Gachibowli: '61f22f7bb2e70b55eca2c6b7'
}

export const designDepartment = '5cb70b89ffa4965f53aa22d8';
export const salesDepartment = '5cb5b38bcf5531e174cb23e0';
export const opsTeam = '62beef6ad75fa548e7a03d30';

export const LOCATIONID = {
    bangalore: '61e7faac331230532d894dbf',
    hyderabad: '61f22f30b2e70b55eca2c127'
}

export const rolesId = {
    designHead: '6253d10559e133b2384c5d97',
    designUser: '61c030feb011183618a10051',
    designManager: '61515c24b2880930387b804d',
    operationDesignManager: '64f5a95b531066078419c584',
    docsUploader: '629ee2e321eccd6f346be0a4'
}

export const constantDepartmentId = {
    admin:"62987d4fbc5b5470cad5a399",
    marketing: '62833e4c6999f0dd8be397a0',
    design: '5cb70b89ffa4965f53aa22d8',
    sales: '5cb5b38bcf5531e174cb23e0',
    factory: '5cb5b3f2cf5531e174cb2457',
    imos: '5cb5b412cf5531e174cb2480',
    operation: '62beef42d75fa548e7a03cff',
    chm: '637b3a50a3d82d3d63bfc6cf',
    callCenter: '664f388651d2a5565b07c43e',
    TeleCallerUser : '66445875fa9dfc06260ddbd9',
    FinanceDepartment: '5cb5b3b2cf5531e174cb240e',
}
export const referalPolicy = {
    url : "https://qt-snag-attachment.s3.amazonaws.com/6294464623.1_Test%20vii/1743148703597_Referal_Policy.jpeg"
}
export const CALL_REPORT_DEPARTMENTS = [
    { name: "Sales" },
    { name: "Design" },
    { name: "Marketing" },
    { name: "Call Center" },
    { name: "Factory" },
    { name: "Operations" },
];

export const CALL_REPORT_DEPARTMENT_ROLE_MAP = {
    Sales: [
        ROLENAME.SalesUser,
        ROLENAME.AssistantSalesManager,
        ROLENAME.SalesManager,
        ROLENAME.AGMSales,
        ROLENAME.DGM_Sales,
        ROLENAME.SalesHead,
    ],
    Design: [
        ROLENAME.DesignUser,
        ROLENAME.AssistanceDesignManager,
        ROLENAME.DesignManager,
        ROLENAME.OperationDesignManager,
        ROLENAME.AGM_Design,
        ROLENAME.DGM_Design,
        ROLENAME.DesignHead,
    ],
    Marketing: [
        ROLENAME.MarketingUser,
        ROLENAME.MarketingManager,
        ROLENAME.DGM_Marketing,
    ],
    CallCenter: [
        ROLENAME.TeleCallerUser,
        ROLENAME.TeleCallerManager,
        ROLENAME.TeleCallerAssistantManager,
    ],
    Factory: [
        ROLENAME.FactoryManager,
        ROLENAME.FactoryCrmUser,
        ROLENAME.FactoryBom,
        ROLENAME.SiteBom,
        ROLENAME.ProductionManager,
        ROLENAME.SnagView,
        ROLENAME.HardwareSnagDispatcher,
    ],
    Operations: [
        ROLENAME.OperationManager,
        ROLENAME.SeniorOperationManager,
        ROLENAME.OperationHead,
        ROLENAME.DGM_Ops,
        ROLENAME.BOMManager,
        ROLENAME.BOMExecutive,
        ROLENAME.ProcurementExecutive,
        ROLENAME.IMOSManager,
        ROLENAME.IMOSUser,
        ROLENAME.Execution_Manager,
        ROLENAME.ExecutionUser,
        ROLENAME.Store_Manager,
    ],
};

export const CALL_REPORT_USER_DEPARTMENT_ID_TO_FILTER = {
    [constantDepartmentId.sales]: "Sales",
    [constantDepartmentId.design]: "Design",
    [constantDepartmentId.marketing]: "Marketing",
    [constantDepartmentId.factory]: "Factory",
    [constantDepartmentId.operation]: "Operations",
    [constantDepartmentId.callCenter]: "Call Center",
};

export const getCallReportRolesForDepartments = (departments = []) => {
    const roleNames = new Set();
    departments.forEach((dept) => {
        (CALL_REPORT_DEPARTMENT_ROLE_MAP[dept.name] || []).forEach((role) =>
            roleNames.add(role)
        );
    });
    return Array.from(roleNames).map((name) => ({ name }));
};

export const SpecificUserCategory = {
    vendorCategory : '6734a96d9392b02687afc7ed',
    jobCategory : '66a39983ccb1c57e49f2b2f3',
    serviceCategory : '6734a9979392b02687afcc35'
}
//for software download
export const software = {
    naraciWindows :"https://naraci-production.s3.amazonaws.com/naraci-installer/windows/NARACI_9.1.0.exe",
    naraciMac :"https://naraci-production.s3.amazonaws.com/naraci-installer/mac/NARACI-9.1.0.dmg",
    sketchUp :"https://dp-test-staging.s3.ap-south-1.amazonaws.com/ATTACHMENT/1747461.1/1712214096854_sketchup_0404202407013684.rar",
    autoCad :"https://dp-test-staging.s3.ap-south-1.amazonaws.com/ATTACHMENT/1747461.1/1712216493862_autocad_0404202407413385.rar",
    autoCadVideo : "https://dp-test-staging.s3.ap-south-1.amazonaws.com/ATTACHMENT/1747336.1/1715237736431_Installation_guide_Autodesk_AutoCAD_0905202406553642.mp4",
    naraciMacVideo : "https://dp-test-staging.s3.ap-south-1.amazonaws.com/ATTACHMENT/1747336.1/1715237763619_Installation_guide_Naraci_mac_0905202406560361.mp4",
    naraciWindowsVideo : "https://dp-test-staging.s3.ap-south-1.amazonaws.com/ATTACHMENT/1747336.1/1715237774399_Installation_guide_Naraci_windows_0905202406561439.mp4",
    sketchUpVideo : "https://dp-test-staging.s3.ap-south-1.amazonaws.com/ATTACHMENT/1747336.1/1715237783742_Installation_guide_SketchUp_0905202406562374.mp4",
    snagApp : "https://qt-snag-attachment.s3.ap-south-1.amazonaws.com/1811851.1_quotation+check/1763047711610_application-80388a77-a137-4c3c-ad49-21f00b429642.apk"
}


export const constantUnitTypeMaster = {
    Sqft: '5ca989cc4585958841722acd',
    mm: '5ca98a104585958841722b26'
}

export const rftUnitTypeId = '61497a00631f527959443fd5';
export const virtualPaymentId = '64f6e042afc49f16a60f9ff2';

export const constantPlyTypeMaster = {
    plywood: '62833b70a4170cdc752d86a7'
} 

export const CONST_USER_ID = {
	Kanishka: "61543da213b518292f34a854",
	Swapna: "61262a8b56f00a0a9245a707",
    Deepak: "61ceedb0451c99174f712634",
    Shomil: "6126288a56f00a0a9245a6e5",
};
export const SriKrishnaId = "649abe224cff80287aa160c1";
export const PalisettiTejaId = "62cd13a726c3cf4d62910416";
export const ThirumaleshId = "6463810d91e79e0d4157af7d";
export const PalaPrasanthKumarId = "656dbe6b68c2676c6b0cb4ce";

export const DONT_SHOW_REMAP_TABLE = ['brijeshkumar@decorpot.com', 'muralikrishnam@decorpot.com']

export const factoryCRMstagesArr = [
    "Assign To IMOS User",
    "100% Material Received & Site BOM In-progress",
    "Assign To IMOS User & Site BOM Completed",
    "Assign To IMOS User & Site BOM In-progress",
    "Assign To IMOS User null",
    "Completed",
    "Completed-MWP",
    "Site QC",
    "IMOS Completed & Site BOM Completed",
    "IMOS Completed & Site BOM In-progress",
    "IMOS Drawing In-Progress & Site BOM Completed",
    "Ready for dispatch",
    "Under Execution",
    "Under Procurement",
    "Under Procurement & Site BOM In-progress",
    "Under Production - Fixing",
    "Under Production - Fixing & Site BOM In-progress",
    "Under Production - Machine & Site BOM In-progress",
    "100% Material Received & Site BOM In-progress",
    "Under Production - Machine"
]
export const paymentMode = {
    upi: "UPI",
    cashFree: "Cash Free - ERP",
    phonePe  : "PhonePe - ERP",
    bankTransferVirtualAccount: "Bank Transfers - Virtual Account",
    cardPineLabsErp: "Card - Pine Labs (via ERP)",
    cheque: "Cheque",
    cardPineLabsNotErp: "Card - Pine Labs (not via ERP)",
    bankTransferNonVirtualAccount: "Bank Transfers - Non Virtual Account",
    cash: "Cash",
    others: "Others",
};
export const paymentModeType = {
    automatic: "Automatic", 
    manual: "Manual",
};

export const saleLostApprovalHeader = 'Sales Lost Leads Approval Requests'
export const designLostApprovalHeader = 'Design Lost Leads Approval Requests'

export const chmTeamTaggingArr = ["Refund / Referral / Balance Sheet / Invoice", "Other-Finance", "Procurement / Vendor / Carpenter Issue", "Marketing", "Service / Others", "Operation / Factory / Material Delivery", "Site Related", "Career / HR / Job Related"]
export const chmCentreWiseTaggingArr = ["Design", "Sales"]

export const sentForApproval = 'Sent for Approval';

export const refundCategory = {
    damage: 'Damages',
    damageId: '6627b4ee73828b62cb2de7bf',
    delayPenality: 'Delay Penality',
    delayPenalityId: '66278ef073828b62cb2de7b3',
    goodWillDisc: 'Good Will Discount',
    goodWillDiscId: '6627b58773828b62cb2de7c0',
    other: 'Other',
    otherId: '6627b5a673828b62cb2de7c1',
    referralBonus: 'Referral Bonus',
    referralBonusId: '6627b5e973828b62cb2de7c2',
};
export const finalizationOfMaterialStages = ['Sent for ADM approval', 'Client Submitted', 'Sent for client approval', 'Approved' ]
export const designFinalizationOfMaterialStages = ['Sent for ADM approval', 'Sent for client approval','Approved', 'Not Initiated' ]

export const poFirstApproverName = {
    firstApprover: "Kanishka",
    type: "OPEN PO",
};

export const marketingUserEmails = [
    "swathikumar@decorpot.com",
    "ashoka.bharadwaj@decorpot.com",
    "aakarsh.ayachit@decorpot.com",
    "vishnu.priya@decorpot.com",
    "rashmi.shetty@decorpot.com"
];
export const isDK = {
    email:"dk@decorpot.com"
}

export const vendorManagerObjectId = {
    deepakMahadev:"63590f1812b5d00af4b1eb7b"
}

export const drawingQCStages = {
    admInProgress: 'ADM In Progress',
    admCompleted: 'ADM Completed',
    qcAssignmentPending: 'QC Assignment Pending',
    admRejected: 'ADM Rejected',
    qc1InProgress: 'QC1 In Progress',
    qc1Completed: 'QC1 Completed',
    qc2InProgress: 'QC2 In Progress',
    qc2CorrectionNeeded: 'QC2 Correction Needed',
    qc2Completed: 'QC2 Completed',
    finalSignoffInProgress: 'Final Signoff In Progress',
    finalSignoffCompleted: 'Final Signoff Completed'
};

export const IP = {
    testUrl : "http://65.0.23.165:3000/",
    localUrl : "http://localhost:3000/",
    prodUrl : "https://erp.decorpot.com/",
    inventoryLocalURL : "http://localhost:3005",
    inventoryTestURL : "http://65.0.23.165:3005",
    inventoryProdURL : "https://inventoryerp.decorpot.com"
}

export const NarenEmail = {
    email: "naren.pradhan@decorpot.com"
}

export const moveToMarketingReasons = [
    { _id: "budget_issue", name: "Budget Issue" },
    { _id: "scope_of_work", name: "Scope of Work (SOW)" },
    { _id: "project_timeline", name: "Project Timeline" },
    { _id: "out_of_city", name: "Out of City (OOC)" },
    // { _id: "no_response", name: "No Response (RNR)" },
    { _id: "duplicate_lead", name: "Duplicate Lead" },
    { _id: "no_response", name: "No Response (RNR) / Invalid / Switched Off / Unreachable" },
    { _id: "job_competitor_vendor", name: "Job / Competitor / Vendor" },
    // { _id: "ec_transfer", name: "Experience Center Transfer (EC Transfer)" },
    // { _id: "already_finalized", name: "Already Finalized" },
    { _id: "others", name: "Others" },
];   

export const salesLostReasons = [
    { _id: "budget_mismatch", name: "Budget Mismatch" },
    { _id: "design_gap", name: "Design Gap" },
    { _id: "trust_orm", name: "Trust/ORM" },
    { _id: "competition", name: "Competition" },
    { _id: "process", name: "Process" },
    { _id: "timing", name: "Timing" },
    { _id: "others", name: "Others" },
];

export const junkReasons = [
    { _id: "junk_budget", name: "Junk - Budget" },
    { _id: "junk_sow", name: "Junk - SOW" },
    { _id: "hold_timeline", name: "Hold - Timeline" },
    { _id: "junk_ooc", name: "Junk - OOC" },
    { _id: "junk_no_response", name: "Junk - No Response" },
    { _id: "junk_duplicate", name: "Junk - Duplicate" },
    { _id: "junk_invalid", name: "Junk - Invalid" },
    { _id: "junk_competitor", name: "Junk - Competitor" },
    { _id: "junk_finalized", name: "Junk - Finalized" },
    { _id: "junk_budget_time", name: "Junk - Budget/Time" },
    { _id: "junk_others", name: "Junk - Others" },
    { _id: "junk_not_looking_for_interiors", name: "Junk - Not Looking for Interiors." },
];

export const approvalStageMap = {
    sentToMarketingForApproval: "Marketing Manager",
    "Sent to BotWot For M2M": "Customer (BotWot Campaign)",
    "Sent to AGM/DGM For M2M": "AGM/DGM"
};

/** Move to Marketing: block when leadAssignedDate is more than this many days ago (UI-only). */
export const MOVE_TO_MARKETING_MAX_DAYS_SINCE_ASSIGNMENT = 15;

export function daysSinceLeadAssigned(leadAssignedDate) {
    if (!leadAssignedDate) return null;
    const assigned = new Date(leadAssignedDate);
    if (Number.isNaN(assigned.getTime())) return null;
    return (Date.now() - assigned.getTime()) / (1000 * 60 * 60 * 24);
}

export function isMoveToMarketingBlockedByAssignmentAge(
    leadAssignedDate,
    maxDays = MOVE_TO_MARKETING_MAX_DAYS_SINCE_ASSIGNMENT
) {
    const days = daysSinceLeadAssigned(leadAssignedDate);
    if (days === null) return false;
    return days > maxDays;
}

export function moveToMarketingAssignmentAgeMessage(
    maxDays = MOVE_TO_MARKETING_MAX_DAYS_SINCE_ASSIGNMENT
) {
    return `Move to Marketing is not allowed more than ${maxDays} days after the lead was assigned to Sales (even if call recordings exist).`;
}

export const DiwakarYadavEmail = {
    email: "diwakar.yadav@decorpot.com"
};

export const cutoffDate = new Date("2026-04-01");

export const allowedDepartments = ["sales", "marketing"];

export const excludedStages = [
  "won",
  "won deals pending designer assignment"
];

// Chennai's Anna Nagar and OMR experience centres carry a higher discount
// ceiling than the discount master's default. Everything outside those two
// centres keeps whatever ceiling the existing rules worked out.
export const REVISED_MAX_DISCOUNT_CITY = "chennai";
export const REVISED_MAX_DISCOUNT_ECS = ["anna nagar", "omr"];
export const REVISED_MAX_DISCOUNT_PERCENT = 30;

// Matched on a word boundary rather than equality, so a centre stored as
// "Chennai - Anna Nagar" or "OMR Branch" still qualifies. The city is already
// pinned to Chennai by the caller, so a short token like "omr" cannot collide
// with a centre in another city.
const matchesRevisedDiscountEc = (ecName) =>
  REVISED_MAX_DISCOUNT_ECS.some((target) =>
    new RegExp(`(^|[^a-z])${target}([^a-z]|$)`).test(ecName)
  );

// Returns the discount ceiling to use for a project. Only ever raises the
// ceiling - a project that already allows more than 30% is left untouched, so
// this cannot make any existing case more restrictive than it is today.
export const applyRevisedMaxDiscount = (projectDetails, maxAllowed) => {
  const city = (projectDetails?.experienceCenterId?.locationId?.name || "")
    .trim()
    .toLowerCase();
  const ecName = (projectDetails?.experienceCenterId?.name || "")
    .trim()
    .toLowerCase();

  if (city === REVISED_MAX_DISCOUNT_CITY && matchesRevisedDiscountEc(ecName)) {
    return Math.max(Number(maxAllowed) || 0, REVISED_MAX_DISCOUNT_PERCENT);
  }
  return maxAllowed;
};

export const COLORS = [
  "#f44336", // red
  "#e91e63", // pink
  "#9c27b0", // purple
  "#673ab7", // deep purple
  "#3f51b5", // indigo
  "#2196f3", // blue
  "#03a9f4", // light blue
  "#00bcd4", // cyan
  "#009688", // teal
  "#4caf50", // green
  "#8bc34a", // light green
  "#cddc39", // lime
  "#ffc107", // amber
  "#ff9800", // orange
  "#ff5722", // deep orange
  "#795548", // brown
  "#9e9e9e", // grey
  "#607d8b", // blue grey
  "#ff6f61", // coral
  "#6a1b9a"  // dark purple
];

export const ERPSAchievementPercentage = {
    "60%": 60,
    "70%": 70,
    "80%": 80,
    "90%": 90,
    "100%": 100
};
export const hideSidebarInCodeLevel = ["abhishek@pratithi.com"]

// AI Expected Design Sign-off Date / AI Design Hold (manageProjectLog) messages
export const AI_NO_CONVERSATION_MSG = 'No conversation found with the designer in Runo calls or in Notes. Make a Runo call or upload the call recording in Notes.';
export const AI_NO_LEAD_CONVERSATION_MSG = 'No conversation found on this lead in Runo calls or in Notes. Make a Runo call or upload the call recording in Notes.';
export const AI_CONVERSATION_NOT_SUPPORTED_MSG = 'The latest conversation or audio file is not supported for analysis. You can upload the latest conversation in Notes or make a Runo call.';
export const AI_PRECHECK_FAILED_MSG = 'Could not check conversations. Please try again.';

// ── Masking phone numbers inside free-text log entries ──────────────────────
//
// Deal Activity / Notes are built from the lead's own form data, so an
// automation-created lead carries the customer's mobile inside its NAME
// ("AI Bot Lead 7013184040") and its EMAIL ("7013184040@leads.decorpot.com") -
// in full, right beside the "Phone Number: XXXXXXXX40" line that was correctly
// masked.
//
// Two rules, deliberately belt-and-braces:
//   1. The customer's own number, when customerId.contact_no gives us enough to
//      identify it. That value is itself stored masked ("XXXXXXXX40"), with the
//      real digits only in contact_no_encrypted, so usually all it exposes is
//      the trailing two - enough to pin a 10-digit run to THIS lead.
//   2. Failing that, ANY bare 10-digit run. A 10-digit number sitting in a lead
//      log is a phone number often enough that showing it is the worse mistake.
//
// Display only - the stored log text is untouched, so exports, the API and
// existing records are unaffected.
//
// Boundaries, and what each one protects:
//   (^|[^\d-])  not continuing a longer digit run, and not following a hyphen
//   (?![\d-])   same on the trailing side
// The hyphen halves are what keep the "Unique Lead Number" UUID intact -
// 42876f04-7377-4e57-8965-2cd61259e2be - since every UUID group is hyphen-bound.
// Letters are deliberately ALLOWED on both sides, because that is the whole
// point: "divakar8768777776@decorpot.com" buries the number mid-token and still
// has to be caught.
//
// A capture group is used instead of a lookbehind on purpose: lookbehind throws
// a SyntaxError on Safari below 16.4, which would take the whole page down.
const escapeRe = (str) => String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const maskPhoneNumbersInLogText = (text, contactNo) => {
    if (!text) return text;

    const digits = String(contactNo || '').replace(/\D/g, '');

    // Rule 1: a run ending in whatever real digits the stored mask exposes.
    // Rule 2 (\d{10}) is a superset of it, so this only matters when the stored
    // value turns out to be LONGER or shorter than 10 - it keeps the customer's
    // own number matched even then.
    const customerCore =
        digits.length >= 2 && digits.length < 10
            ? `\\d{${10 - digits.length}}${escapeRe(digits)}`
            : null;

    const core = customerCore ? `${customerCore}|\\d{10}` : '\\d{10}';

    // The optional 91 lets "+919876543210" match rather than the country code
    // blocking the boundary.
    const re = new RegExp(`(^|[^\\d-])(?:\\+?91[-\\s]?)?(${core})(?![\\d-])`, 'g');

    return String(text).replace(
        re,
        (match, lead, number) => `${lead}XXXXXXXX${number.slice(-2)}`
    );
};

export const DSO_PAYMENT_VARIANCE_THRESHOLD_PERCENT = 30;

/** Reduction vs sales won when design quote is below sales; 0 if design ≥ sales. */
export function salesVsQuotationVariancePercent(staticSalesWonAmount, quotationAmount) {
    const sales = Number(staticSalesWonAmount) || 0;
    const quote = Number(quotationAmount) || 0;
    if (sales <= 0 || quote >= sales) return 0;
    return ((sales - quote) / sales) * 100;
}

/** DGM approval only when design sign-off amount is lower than sales won by ≥30%. */
export function requiresDsoPaymentApproval(staticSalesWonAmount, quotationAmount) {
    const sales = Number(staticSalesWonAmount) || 0;
    const quote = Number(quotationAmount) || 0;
    if (sales <= 0 || quote >= sales) return false;
    return salesVsQuotationVariancePercent(sales, quote) >= DSO_PAYMENT_VARIANCE_THRESHOLD_PERCENT;
}

export function isDsoPaymentApprovedForLead(lead, quotationAmount) {
    if (!requiresDsoPaymentApproval(lead?.staticSalesWonAmount, quotationAmount)) {
        return true;
    }
    return (
        lead?.dsoPaymentApproval === true &&
        Number(lead?.dsoPaymentApprovedAmount) === Number(quotationAmount)
    );
}

export const DSO_PENDING_DESIGNER_MOVE_BLOCK_MESSAGE =
    'This project is pending DGM approval for design sign-off variance. You cannot move the lead until it is approved or rejected.';

export function isDesignerBlockedWhileDsoPending(lead) {
    return lead?.dsoPaymentApprovalStatus === 'Sent for Approval';
}